import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const JavaIdeAndroid: React.FC = () => (
  <SEOLandingPage
    title="Java IDE for Android — Code, Compile & Run Java on Your Phone | Cosmovex"
    metaDescription="Java Compiler & IDE Editor for Android. Write, compile, and run Java programs on your phone without a PC. Syntax highlighting, error diagnostics, and offline support."
    ogTitle="Java IDE for Android — Java Compiler & IDE Editor"
    h1="Java IDE for Android"
    intro="A full Java development environment on your phone. Write real Java code, compile it on-device, and see the output instantly — no PC, no cloud, no waiting."
    paragraphs={[
      "Most developers think of Android as a place to run apps, not write them. Java Compiler & IDE Editor changes that. It brings a proper Java development workflow to your phone — syntax highlighting, real compilation via an embedded JDK, and immediate output in a terminal-style console.",
      "Whether you're a student testing algorithms during a commute, or a professional who needs to prototype logic on the go, having a real Java IDE in your pocket removes the dependency on a laptop. The editor understands Java syntax, flags errors before you compile, and lets you iterate fast.",
      "The app works completely offline. No internet connection is required to compile or run your Java programs. Your code stays on your device and never touches a server. This makes it ideal for classrooms, flights, or any situation where connectivity is unreliable.",
      "Java Compiler & IDE Editor supports standard Java constructs including classes, interfaces, generics, collections, file I/O, and exception handling. You can write multi-class programs, manage multiple files, and organize your code into a proper project structure.",
    ]}
    features={[
      "On-device Java compilation — no server required",
      "Syntax highlighting with Java-aware editor",
      "Real-time error detection before compile",
      "Terminal-style console output",
      "Multi-file project support",
      "Works fully offline",
      "Standard Java library support",
      "Dark theme editor, easy on the eyes",
      "Code templates and snippets",
      "Instant run — tap once, see output",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.javavedit"
    icon="/images/javavedit.png"
    appName="Java Compiler & IDE Editor"
    accentColor="#A8720E"
    canonicalPath="/java-ide-android"
  />
);

export default JavaIdeAndroid;
